import { getAttachmentSources } from './readOnlyAttachmentActions';
import { getUrlMetaImageSources, getUrlMetaVideoSource, getUrlMetaDirectImageUrl } from './url-meta-media';

const text = value => typeof value === 'string' ? value.trim() : '';

export const getSelectedTranscript = message => text(message?.transcript?.text) ||
    text(message?.transcript) ||
    (message?.transcript?.segments?.length ? message.transcript.segments : message?.transcriptionSegments || [])
        .map(segment => text(segment?.text)).filter(Boolean).join('\n');

export const getSelectedImageText = message => text(message?.ocrText) || text(message?.image?.ocrText) ||
    (message?.urlMeta || []).flatMap(meta => meta?.gallery || [])
        .filter(slide => slide?.type !== 'video' && !getUrlMetaVideoSource(slide))
        .map(slide => text(slide?.media?.ocrText) || text(slide?.ocrText)).filter(Boolean).join('\n\n');

// Keep the established oldest-to-newest copy order, independent of click order.
export const orderSelectedMessages = messages => [...(messages || [])].sort((a, b) =>
    (Date.parse(a?.createdAt) || 0) - (Date.parse(b?.createdAt) || 0));

export const buildSelectedText = (messages, kind = 'titles') => {
    const getText = kind === 'transcripts' ? getSelectedTranscript :
        kind === 'imageText' ? getSelectedImageText :
        kind === 'notes' ? message => text(message?.body) : message => text(message?.title);
    const entries = orderSelectedMessages(messages).map(message => ({ message, value: getText(message) }))
        .filter(entry => entry.value);
    return {
        text: entries.map(({ message, value }) => kind !== 'titles' && text(message?.title)
            ? `${text(message.title)}\n${value}` : value).join('\n\n'),
        count: entries.length,
        skipped: (messages || []).length - entries.length
    };
};

export const getSelectedImages = messages => orderSelectedMessages(messages).flatMap(message => {
    const images = [];
    if (getAttachmentSources(message?.image, true).length) {
        images.push({
            name: message.image.displayName || message.image.name,
            sources: getAttachmentSources(message.image, true),
            originalSources: getAttachmentSources(message.image)
        });
    }
    (message?.urlMeta || []).forEach(meta => {
        (meta?.gallery || []).forEach(slide => {
            if (slide?.type === 'video' || getUrlMetaVideoSource(slide)) return;
            const originalSources = [...new Set([...getAttachmentSources(slide?.media), ...getUrlMetaImageSources({ ...slide, thumbnail: undefined })])];
            const sources = [...new Set([...originalSources, ...getUrlMetaImageSources(slide)])];
            if (sources.length) images.push({ name: slide?.media?.displayName || slide?.image_name, sources, originalSources });
        });
        if (!meta?.gallery?.length && meta?.gallery_images?.length) {
            meta.gallery_images.filter(source => typeof source === 'string' && source.trim()).forEach(source =>
                images.push({ sources: [source], originalSources: [source] }));
        } else if (!meta?.gallery?.length && getUrlMetaDirectImageUrl(meta)) {
            const sources = [getUrlMetaDirectImageUrl(meta)];
            images.push({ sources, originalSources: sources });
        }
    });
    return images;
});
